import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiGithub } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
          {/* Logo & Brand */}
          <div className="flex items-center justify-center md:justify-start">
            <Link to="/" className="flex items-center space-x-3 group">
              <img 
                src="/ErgoFocus-Icon.png" 
                alt="" 
                className="w-6 h-6 object-contain"
                aria-hidden="true"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              <div className="flex flex-col leading-none">
                <span className="text-lg font-bold text-white tracking-tight">
                  Ergo<span className="text-orange-500">Focus</span>
                </span>
                <span className="text-[9px] uppercase tracking-widest text-slate-500 font-medium">
                  Pomodoro Timer
                </span>
              </div>
            </Link>
          </div>

          {/* Legal Links */}
          <nav className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" aria-label="Rechtliche Links">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
            <span className="text-slate-600" aria-hidden="true">|</span>
            <span className="cursor-default select-none text-green-500/80 font-medium">100% Cookie-frei</span>
          </nav>

          {/* Social & Copyright */}
          <div className="flex flex-col items-center md:items-end space-y-2">
            <div className="flex items-center space-x-4 text-slate-400">
              <a 
                href="https://github.com/ecomcodeLab" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-white transition-all flex items-center gap-2 group"
                aria-label="Folge ecomcodeLab auf GitHub"
              >
                <SafeIcon icon={FiGithub} className="text-lg group-hover:scale-110 transition-transform" />
                <span className="text-sm font-medium">ecomcodeLab</span>
              </a>
            </div>
            <div className="text-slate-500 text-[10px] uppercase tracking-widest select-none">
              &copy; {new Date().getFullYear()} ErgoFocus • Made by{' '}
              <a 
                href="https://github.com/ecomcodeLab" 
                target="_blank" 
                rel="noopener noreferrer"
                className="hover:text-orange-500 transition-colors"
              >
                ecomcodeLab
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;